<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid" v-bind:id="getId()">
    <div class="row">
      <form class="login-formx form-validate" action="index.html" onsubmit="return false" id="createTagForm">
        <div class="col-lg-12 custom-form-label mt-3">
          {{$t('tag')}}
        </div>
        <div class="col-lg-12 mt-1">
          <v-autocomplete :items="items" v-model="item" :get-label="getLabel" :component-item='template' @update-items="updateItems"
                          :input-class="cssClass" :keep-open="false" @item-clicked="itemClicked" :auto-select-one-item="false"
                          @focus="focusEvent" @change="changeEvent">
          </v-autocomplete>
        </div>

        <div class="col-lg-12 text-right">
          <button @click="savetag" v-if="proSchId>0 || procId>0" type="submit" class="btn skin primary-button mt-1"><i class="icon-cog5 mr-2"></i> {{$t('add')}}</button>
        </div>
      </form>
    </div>
    <div class="row">
      <div class="col-12 mt-3">
        <table class="table" style="color:inherit">
          <tr>
            <td class="custom-form-label" style="padding-left: 0px !important; color: inherit">{{$t('tags')}}</td>
            <td></td>
          </tr>
          <tr v-for="tag in tags" class="mt-1">
            <td align="left" style="padding-left:0px !important;color:inherit">{{ tag.Name }}</td>
            <td align="right"><a @click="deleteTag(tag.Id)" style="color: inherit"><i style="font-size: 16px; color: inherit" class="fa fa-trash-o"></i></a></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  /*https://www.npmjs.com/package/v-autocomplete*/
  import ItemTemplate from './item-template.vue'
  var tags = [];
  var tag = '';
  export default {
    name: "procedureschedule-tag",
    components: {
    },
    props: {
      proSchId: {
        required: false,
        type: String,
        default: null
      },
      procId: {
        required: false,
        type: String,
        default: null
      }
    },
    data() {
      return {
        tags,
        tag: '',

        item: {},
        items: [],
        template: ItemTemplate,
        cssClass: 'v-autocomplete-input form-control txttag'
      };
    },

    methods: {
      changeEvent(text) {
        if (text === '') {
          this.items = [];
        }
      },
      focusEvent() {
        $('#createTagForm').find('#-error').remove();

        if (this.items.length === 0) {
          $('.v-autocomplete-list').hide();
        } else {
          $('.v-autocomplete-list').show();
        }
      },
      itemClicked(item) {
        //alert(this.item.name);
        this.item = item;
      },
      getLabel(item) {
        return item.name
      },
      updateItems(text) {
        try {
          this.item = { id: -1, name: text };
          

          if (typeof (this.proSchId) != "undefined" && this.proSchId != null && this.proSchId != "" && this.proSchId > 0) {
            this.$http.get('/api/Procedures/v1/GetProcSchsTags?procSchId=' + this.proSchId + '&text=' + text).then(async response => {
              this.items = response.data;
            });
          }

          else if (typeof (this.procId) != "undefined" && this.procId != null && this.procId != "" && this.procId > 0) {
            this.$http.get('/api/Procedures/v1/GetProceduresTags?procId=' + this.procId + '&text=' + text).then(async response => {
              this.items = response.data;
            });
          }


        } catch (err) {
          alert('some error:' + err)
        }
      },

      clearFields() {
        this.tag = '';
        this.$forceUpdate();
      },
      getId() {
        return "child_" + this._uid;
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      async loadTags() {
        try {
          this.clearFields();
          this.tags = [];
          if (typeof (this.proSchId) != "undefined" && this.proSchId != null && this.proSchId != "" && this.proSchId > 0) {
            this.$http.get('/api/Procedures/v1/GetProcSchTags?procSchId=' + this.proSchId).then(async response => {
              this.tags = response.data;
              //Vue.set(this, "tags", this.tags);
              this.$forceUpdate();
            });
          }

          else if (typeof (this.procId) != "undefined" && this.procId != null && this.procId != "" && this.procId > 0) {
            this.$http.get('/api/Procedures/v1/GetProcedureTags?procId=' + this.procId).then(async response => {
              this.tags = response.data;
              //Vue.set(this, "tags", this.tags);
              this.$forceUpdate();
            });
          }

        } catch (err) {
          alert('some error:' + err)
        }
      },
      async deleteTag(id) {
        try {
          var msg = this.$t('confirm_delete')
          if (confirm(msg)) {
            if (typeof (this.proSchId) != "undefined" && this.proSchId != null && this.proSchId != "" && this.proSchId > 0) {
              this.$http.get('/api/Procedures/v1/DeleteTag?id=' + id).then(async response => {
                this.loadTags();
              });
            }

            else if (typeof (this.procId) != "undefined" && this.procId != null && this.procId != "" && this.procId > 0) {
              this.$http.get('/api/Procedures/v1/DeleteProcedureTag?id=' + id).then(async response => {
                this.loadTags();
              });
            }
          }
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async savetag() {
        if (!$('#createTagForm').valid())
          return false;

        try {
          if (typeof (this.proSchId) != "undefined" && this.proSchId != null && this.proSchId != "" && this.proSchId > 0) {
            var request = { tag: this.item.name, procSchId: this.proSchId };
            var response = await this.$http.post(
              '/api/Procedures/v1/AddProcSchTag',
              request
            ).then(async response => {
              this.clearFields();
              this.loadTags();
            })
          }

          else if (typeof (this.procId) != "undefined" && this.procId != null && this.procId != "" && this.procId > 0) {
            var request = { tag: this.item.name, procId: this.procId };
            var response = await this.$http.post(
              '/api/Procedures/v1/AddProcedureTag',
              request
            ).then(async response => {
              this.clearFields();
              this.loadTags();
              vm.$root.$emit('addtag');
            })
          }
        } catch (err) {

        }
      },
    },
    computed: {
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 25");
          this.$store.commit('saveprocedure', value)
        }
      }
    },
    mounted() {
      _componentValidation('#createTagForm');
      $('.txttag').rules("add",
        {
          required: true
        });
    },

    created: function () {

    },

    watch: {

    },
    created() {
    },
  };

</script>
<style>
  /*.v-autocomplete .v-autocomplete-input-group .v-autocomplete-input {
    font-size: 1.5em;
    padding: 10px 15px;
    -webkit-box-shadow: none;
    box-shadow: none;
    border: 1px solid #157977;
    width: calc(100% - 32px);
    outline: none;
    background-color: #eee
  }

  .v-autocomplete .v-autocomplete-input-group.v-autocomplete-selected .v-autocomplete-input {
    color: green;
    background-color: #f2fff2
  }*/

  .v-autocomplete .v-autocomplete-list {
    width: 100%;
    text-align: left;
    border: none;
    border-top: none;
    max-height: 400px;
    overflow-y: auto;
    border-bottom: 1px solid #ccc
  }

    .v-autocomplete .v-autocomplete-list .v-autocomplete-list-item {
      cursor: pointer;
      background-color: #fff;
      padding: 10px;
      border-bottom: 1px solid #ccc;
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc
    }

      .v-autocomplete .v-autocomplete-list .v-autocomplete-list-item:last-child {
        border-bottom: none
      }

      .v-autocomplete .v-autocomplete-list .v-autocomplete-list-item:hover {
        background-color: #eee
      }

      .v-autocomplete .v-autocomplete-list .v-autocomplete-list-item abbr {
        opacity: .8;
        font-size: .8em;
        display: block;
        font-family: sans-serif
      }


  .v-autocomplete {
    position: relative;
  }

    .v-autocomplete .v-autocomplete-list {
      position: absolute;
      z-index: 9;
    }

      .v-autocomplete .v-autocomplete-list .v-autocomplete-list-item {
        cursor: pointer;
      }

        .v-autocomplete .v-autocomplete-list .v-autocomplete-list-item.v-autocomplete-item-active {
          background-color: #f3f6fa;
        }
</style>
<style scoped>

  .table td {
    padding: 10px !important;
    padding-top: 5px;
    border-bottom: 1px solid #ddd;
    border-top: 0px solid #ddd;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedureschedule-tag.vue